export enum ErpClaimCode {
    CUSTOMER_ACTIVE_ROLE,
    CUSTOMER_ECOM_ROLE,
    CUSTOMER_CALC_ROLE,
    CUSTOMER_ACCOUNT_ROLE,
    CUSTOMER_VIEWP_ROLE,
    CUSTOMER_BDC_ROLE,
    CUSTOMER_ISADMIN_ROLE,
    CUSTOMER_INSLEEP_ROLE
}